import { adminHttpClient } from '../commons/adminHttpClient'
import { ProductIds } from '../commons/config'
import { AuthResponse } from './auth'

const switchProductForCompanyUser = (companyId: string, productId: ProductIds): Promise<AuthResponse> => {
  return adminHttpClient.put('/Account/SwitchProductForCompanyUser', { companyId, productId })
}

export default switchProductForCompanyUser
